import {createBrowserHistory} from 'history';

// This is used for navigating in the redux actions
let historyClient;

if (typeof document !== 'undefined') {
	historyClient = createBrowserHistory()
}

export const history = historyClient;